export default "__VITE_ASSET__be63e1cc__"